import { render, staticRenderFns } from "./MapStylePropertiesList.vue?vue&type=template&id=3fa80f4c&scoped=true"
import script from "./MapStylePropertiesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapStylePropertiesList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MapStylePropertiesList.vue?vue&type=style&index=0&id=3fa80f4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa80f4c",
  null
  
)

export default component.exports